export default {
  common: {
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    notifications: 'Notifications',
    billing: 'Facturation',
    profile: 'Profil',
    logout: 'Déconnexion',
  },
  chatbot: {
    title: 'Base de connaissances',
    noDataSources: 'Aucune source de données n\'existe',
    addDataSource: 'Ajouter une source de données',
    searchPlaceholder: 'Rechercher dans la base de connaissances...',
    learnMore: 'En savoir plus',
    dataSourceTypes: {
      urls: 'URL(s)',
      sitemap: 'Plan du site',
      uploadFile: 'Télécharger un fichier',
      plainText: 'Texte brut',
      zendesk: 'Zendesk',
    }
  },
  voice: {
    title: 'Agent Vocal',
    createAgent: 'Créer un agent',
    phoneNumbers: 'Numéros de téléphone',
    batchCall: 'Appel groupé',
    callHistory: 'Historique des appels',
    analytics: 'Analytique',
    billing: 'Facturation',
    apiKeys: 'Clés API',
    webhooks: 'Webhooks',
  },
  management: {
    title: 'Gestion',
    userManagement: 'Gestion des utilisateurs',
    adminList: 'Liste des administrateurs',
  }
}; 